export const APPLICATION_DISCLOSURE = 'APPLICATION_DISCLOSURE';
export const CLOSING_DISCLOSURE = 'CLOSING_DISCLOSURE';
export const NOTARY_DISCLOSURE = 'NOTARY_DISCLOSURE';
export const SUMMARY_DISCLOSURE = 'SUMMARY_DISCLOSURE';

export const RIGHTNOTTOCLOSE = 'RIGHTNOTTOCLOSE';
export const AUTOPAYAGREEMENT = 'AUTOPAYAGREEMENT';
export const PL_AGREEMENT = 'PL_AGREEMENT';
